import { useCalendarLinkedContext } from './useCalendarLinkedContext';

/**
 * 학사일정 섹션에 연결된 클래스 기준 학년도(선택 UI 없음).
 * MainLayout `CalendarLinkedContextProvider`와 동일한 `workspaceId`·`gradeId`면 resolve를 공유합니다.
 */
export function useCalendarLinkedAcademicYear(
  workspaceId: string,
  gradeId: string,
  options?: { localOnly?: boolean }
): number {
  return useCalendarLinkedContext(workspaceId, (gradeId ?? '').trim(), options).academicYear;
}
